<div class="card m-2">
  <div class="card-body">
    <h2>
      <b>{{ authorization.CustomerName }}</b>
    </h2>
    <p>
      <b>{{ sharedService.processICNum(authorization.CustomerIC) }}</b>
    </p>
    <div class="row">
      <div class="col-10">
        <p>
          <i class="far fa-comment-alt"></i> {{ authorization.Remark }} <span class="text-muted fw-bold">({{ customerAccount.CreatedBy }} | {{ customerAccount.CreatedAt | date: "dd-MM-yyyy" }})</span>
        </p>
        @if (customerAccount != undefined) {
          <p class="text-muted fw-bold">
            <i class="fas fa-university"></i>
            {{ customerAccount.Bank }}
            | {{ customerAccount.AccountNumber }} | {{ customerAccount.HolderName }}
          </p>
        }
      </div>
      <div class="col-2">
        <button class="btn btn-info" (click)="openProcessAuthorizationModal()"><i class="fas fa-info"></i> Details</button>
      </div>
    </div>
  </div>
</div>
